import { useEffect } from 'react';
import useScrollBehavior from '../../landing/useScrollBehavior';
import Footer from '../components/footer';
import Header from '../components/header';
import './privacyPolicy.css';
import {
    CONTACT_EMAIL,
    POLICY_INTRO,
    POLICY_SECTIONS,
    PolicyBlock,
} from './privacyPolicy.content';

function renderBlocks(blocks: PolicyBlock[], keyPrefix: string) {
    return blocks.map((block, index) => {
        if (block.type === 'list') {
            return (
                <ul key={`${keyPrefix}-${index}`} className="inform__policy-list">
                    {block.content.map((item) => (
                        <li key={item}>{item}</li>
                    ))}
                </ul>
            );
        }

        return <p key={`${keyPrefix}-${index}`}>{block.content}</p>;
    });
}

export default function Inform3DPrivacyPolicy() {
    const { scrollToTop } = useScrollBehavior();

    useEffect(() => {
        scrollToTop("auto");
    }, [scrollToTop]);

    return (
        <div id="app">
            <Header />
            <main id="main-content">
                <section className="inform__policy-hero">
                    <div className="sp-container-sm">
                        <h1>Privacy Policy</h1>
                        <p>{POLICY_INTRO}</p>
                    </div>
                </section>

                <section className="inform__policy-body">
                    <div className="sp-container-sm">
                        {POLICY_SECTIONS.map((section) => (
                            <section key={section.title} className="inform__policy-section">
                                <h2>{section.title}</h2>
                                {renderBlocks(section.blocks, section.title)}

                                {section.subsections?.map((subsection) => (
                                    <div
                                        key={subsection.title}
                                        className="inform__policy-subsection"
                                    >
                                        <h3>{subsection.title}</h3>
                                        {renderBlocks(subsection.blocks, subsection.title)}
                                    </div>
                                ))}
                            </section>
                        ))}

                        <section className="inform__policy-section">
                            <h2>Contact Information</h2>
                            <p>
                                For questions or concerns regarding this Privacy Policy, please
                                contact us at{' '}
                                <a className="sp-link" href={`mailto:${CONTACT_EMAIL}`}>
                                    {CONTACT_EMAIL}
                                </a>
                                .
                            </p>
                        </section>
                    </div>
                </section>
            </main>
            <Footer />
        </div>
    );
}
